import styled, { keyframes } from 'styled-components';

export const ResourceButtonContainer = styled.button<{
  active: boolean;
  primaryColor: string;
  primaryHoverColor: string;
  secondaryColor: string;
  secondaryHoverColor: string;
  width: string;
  height: string;
  borderColor: string;
}>`
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background-color: ${(props) =>
    props.active ? props.secondaryColor : props.primaryColor};
  border: 2px solid
    ${(props) => (props.active ? props.borderColor : 'transparent')};
  border-radius: 30px;
  padding: 8px 30px;
  cursor: pointer;
  transition: background-color 0.3s, border-color 0.3s;

  &:hover {
    background-color: ${(props) =>
      props.active ? props.secondaryHoverColor : props.primaryHoverColor};
  }

`;

export const ButtonText = styled.span<{ active: boolean }>`
  font-size: 16px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  color: ${(props) => (props.active ? 'rgba(0, 0, 0, 1)' : 'rgba(0, 0, 0, 0.5)')};
  opacity: 1;
  transition: opacity 0.3s;
`;

export const ButtonImage = styled.img<{ active: boolean }>`
  width: auto;
  height: 20px;
  margin-right: 10px;
  opacity: ${(props) => (props.active ? 1 : 0.5)};
  transition: opacity 0.3s;
`;

export const RippleEffect = styled.span<{
  left: number;
  top: number;
}>`
  position: absolute;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  transform: scale(0);
  animation: ripple-animation 0.6s linear;
  pointer-events: none;
  z-index: -1;

  @keyframes ripple-animation {
    to {
      transform: scale(3);
      opacity: 0;
    }
  }
`;